module.exports = __webpack_public_path__ + "static/media/paid_course_csknew.c3ab79f9.png";